import { Component } from '@angular/core';

interface FooterLink {
  label: string;
  route: string[];
  fragment?: string;
  queryParams?: Record<string, string>;
}

interface FooterSection {
  title: string;
  links: FooterLink[];
}

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  contactInfo = [
    {
      icon: 'images/marker-icon.svg',
      title: 'ul. Marii Zientary-Malewskiej 30/5, 10-302 Olsztyn, Polska',
    },
    {
      icon: 'images/phone-icon.svg',
      title: 'Zadzwoń: +48 507 372 194',
    },
    {
      icon: 'images/mail-icon.svg',
      title: 'Napisz do nas: sales@brocomindustry.com',
    },
  ];

  footerSections: FooterSection[] = [
    {
      title: 'O nas',
      links: [
        { label: 'Kontakt', route: ['/info/contact'] },
        { label: 'O nas', route: ['/about-us'] },
        { label: 'Blog', route: ['/blog'] }
      ]
    },
    {
      title: 'Obsługa klienta',
      links: [
        { label: 'Metody płatności', route: ['/info/payment-methods'] },
        { label: 'Czas i koszty dostawy', route: ['/info/delivery'] },
        { label: 'Czas realizacji zamówienia', route: ['/info/order-processing'] },
        { label: 'Zwroty i reklamacje', route: ['/info/returns-and-complaints'] }
      ]
    },
    {
      title: 'Pomoc',
      links: [
        { label: 'Jak kupować?', route: ['/info/how-to-shop'] },
        { label: 'Pytania i odpowiedzi', route: ['/info/faq'] },
        { label: 'Regulamin', route: ['/legal/terms-and-conditions'] },
        { label: 'Polityka prywatności', route: ['/legal/privacy-policy'] },
        { label: 'Ustawienia plików cookies', route: ['/legal/cookie-settings'] }
      ]
    },
    {
      title: 'Moje konto',
      links: [
        { label: 'Twoje zamówienia', route: ['/profile'], queryParams: { section: 'orders' } },
        { label: 'Ustawienia konta', route: ['/profile'] },
        { label: 'Ulubione', route: ['/profile/watchlist'] }
      ]
    }
  ];

  openHeaderIndex: number | null = null;

  toggleAccordion(index: number): void {
    this.openHeaderIndex = this.openHeaderIndex === index ? null : index;
  }
}
